import { Radio, RadioGroup, Textarea } from '@nextui-org/react'
import CreateDropZone from './CreateDropZone'

export default function CompanyReferences({ formData, handleChange, userUUID, isForUser }: any) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row gap-4">
        <div className="flex flex-1">
          <Textarea
            label="Reference Project List"
            labelPlacement="outside"
            variant="bordered"
            placeholder="Upload or enumerate key projects."
            classNames={{
              inputWrapper: 'flex flex-1',
            }}
            value={formData?.referenceProjectsText}
            onChange={(e) => handleChange?.('referenceProjectsText', e.target.value)}
          />
        </div>
        <div className="flex flex-1">
          <CreateDropZone
            title={'Portfolio'}
            description="."
            onFilesChange={(files) => handleChange?.('referenceProjectsFile', files)}
            userUUID={userUUID}
            isForUser={isForUser}
            files={formData?.referenceProjectsFile ?? []}
          />
        </div>
      </div>
      <Textarea
        label="Reference Contact Persons"
        labelPlacement="outside"
        variant="bordered"
        placeholder="Contact data for each reference."
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        value={formData?.referenceContactPerson}
        onChange={(e) => handleChange?.('referenceContactPerson', e.target.value)}
      />
      <RadioGroup
        label="Public Sector References"
        onChange={(e) => handleChange?.('hasPublicSectorReferences', e.target.value == 'yes')}
        value={formData?.hasPublicSectorReferences ? 'yes' : 'no'}
      >
        <Radio value="yes">Yes</Radio>
        <Radio value="no">No</Radio>
      </RadioGroup>
      {formData?.hasPublicSectorReferences && (
        <Textarea
          labelPlacement="outside"
          variant="bordered"
          placeholder="Separate disclosure of governmental or publicly funded projects"
          classNames={{
            inputWrapper: 'flex flex-1',
          }}
          value={formData?.publicSectorReferences}
          onChange={(e) => handleChange?.('publicSectorReferences', e.target.value)}
        />
      )}
      <CreateDropZone
        title={'Case Study Documentation'}
        description="Upload case-study slide decks or PDFs."
        onFilesChange={(files) => handleChange?.('caseStudyDocumentation', files)}
        userUUID={userUUID}
        isForUser={isForUser}
        files={formData?.caseStudyDocumentation ?? []}
      />
      <Textarea
        label="Awards & Recognitions"
        labelPlacement="outside"
        variant="bordered"
        placeholder="Third-party accolades underpin claims of excellence and innovation"
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        value={formData?.awards}
        onChange={(e) => handleChange?.('awards', e.target.value)}
      />
    </div>
  )
}
